import { styled } from "styled-components";
import { PricingCard } from "@template/blocks/PricingSection/component/PricingCard/styles.ts";

export const ComparePricingSectionWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background: ${({ theme }) =>
          `linear-gradient(to bottom, ${theme.colors.primary[950]} 400px, ${theme.colors.base} 400px)`};

  ${({ theme }) => theme.breakpoints.sm.query} {
    background: ${({ theme }) =>
            `linear-gradient(to bottom, ${theme.colors.primary[950]} 300px, ${theme.colors.base} 300px)`};
  }

  @media (min-width: 2400px) {
    background: ${({ theme }) =>
            `linear-gradient(to bottom, ${theme.colors.primary[950]} 280px, ${theme.colors.base} 280px)`};
  }

  position: relative;
  overflow: hidden;
`;

export const ComparePricingSectionContainer = styled.div`
  padding: 42px 12px 96px 12px;
  display: flex;
  flex-direction: column;
  gap: 48px;
  align-items: center;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  width: 100%;
`;

export const SliderContainer = styled.div`
  margin-top: 60px;
  display: flex;
  align-items: flex-end;
  gap: 48px;
  width: 100%;
  position: relative;
  padding-right: 12px;

  ${({ theme }) => theme.breakpoints.sm.query} {
    justify-content: center;
  }
`;

export const Arch = styled.div`
  z-index: 0;
  color: ${({ theme }) => theme.colors.base};
  overflow-x: hidden;
  position: absolute;
  top: 300px;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: -8px;

  @media (min-width: 2400px) {
    display: none;
  }
`;

export const PricingCardsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;
  flex-wrap: wrap;

  ${({ theme }) => theme.breakpoints.sm.query} {
    flex-direction: column;
    align-items: center;
  }

  ${PricingCard} {
    width: 285px;
    flex: revert;
    align-items: flex-start;
    border: ${({ theme }) => `1px solid ${theme.colors.default[200]}`};
    background: ${({ theme }) => theme.colors.default[50]};
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.15);
    z-index: 1;

    ${({ theme }) => theme.breakpoints.md.query} {
      width: 100%;
    }
  }
`;
